import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from '@mui/material'

import { MotivationGapLegend } from '../MotivationGapLegend/MotivationGapLegend'

interface MotivationDiagnosisLegendProps {
  /** Game app icon, shown at the gap bar's goalpost marker in place of the dot. */
  gameIcon?: string
}

/**
 * The blind-spot diagnosis legend, mirroring the gap bar's vocabulary
 * (delivered creative fill, uncovered gap hatch, in-game goalpost marker). Kept
 * as its own component so it can render either inline above the gap bars
 * ({@link MotivationDiagnosis}) or hoisted into a section card header.
 */
export const MotivationDiagnosisLegend: FC<MotivationDiagnosisLegendProps> = ({ gameIcon }) => {
  const { t } = useTranslation('ua-insights')
  const theme = useTheme()

  return (
    <MotivationGapLegend
      items={[
        { variant: 'fill', color: theme.palette.primary.main, label: t('motivation_source_creative_ads') },
        { variant: 'hatch', color: theme.palette.error.main, label: t('diagnosis_gap_label') },
        { variant: 'marker', color: theme.palette.secondary.main, label: t('motivation_source_game_design'), icon: gameIcon },
      ]}
    />
  )
}
